import { apiProxyRequest } from "Api/apiProxyRequest";
import { fetchAllPages } from "Api/utils";

import { Project } from "@packages/client";

export type ProfileProjectsResponse = {
  count: number;
  facets: Record<string, unknown>;
  items: Array<Project>;
  _links: Record<string, { href: string }>;
};

export const getProfileProjects = (billingProfileId: string) => {
  return fetchAllPages(
    apiProxyRequest<ProfileProjectsResponse>(
      `/billing/profiles/${billingProfileId}/projects`
    )
  );
};
